<template>
    <div class="carousel-box">
        <div class="carousel-list">
            <div class="img-box">
                <img src="@/assets/img/carousel-01.png" alt="">
            </div>
            <div class="slid-pic">
                <img src="@/assets/img/Slice123.png" alt="">
            </div>
            <div class="text-pic">
                <img src="@/assets/img/Slice124.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    created() {

    },
    methods: {

    },
}
</script>

<style lang='scss' scoped>
.carousel-box {
    position: absolute;
    // right: 150px;
    left: 28%;
    z-index: 2;
    top: 100px;
    bottom: 100px;
    display: flex;
    align-items: center;
    .carousel-list {
        width: 85%;
        height: 100%;
        background: #FFFFFF;
        border-radius: 40px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-box {
            padding: 0px 27px 0;
            img {
                width: 100%;
            }
        }
        .slid-pic {
            margin: 45px 0;
        }
        .text-pic img {
            width: 18.072916vw;
            height: 4.8958333vw;
        }
    }
}
</style>